const Footer = () => {
  return (
    <footer data-testid="footer" className="py-10 px-6 md:px-12 bg-[#F9F6F0] border-t border-[#DCD6CC]">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-['Cormorant_Garamond'] text-lg text-[#1A3626]">
          Doz Aguas
        </p>
        <p className="text-xs text-[#596B5B] tracking-wider">
          &copy; {new Date().getFullYear()} Doz Aguas. Somatic Movement & Sound Healing.
        </p>
        <div className="flex gap-6">
          <a
            data-testid="footer-email-link"
            href="mailto:coral.dozaguass@gmail.com"
            className="text-xs uppercase tracking-wider text-[#596B5B] hover:text-[#CC5543] transition-colors"
          >
            Email
          </a>
          <a
            data-testid="footer-instagram-link"
            href="https://www.instagram.com/doz.aguas/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs uppercase tracking-wider text-[#596B5B] hover:text-[#CC5543] transition-colors"
          >
            Instagram
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
